<template>
  <div class="tabbar-container">
    <zbScrollbar :isKeep="true">
      <!-- 变化背景 -->
      <div class="topbg" :style="{ 'background-color': `${topBackgroundColor}`}"></div>
      <!-- 圆角遮罩 -->
      <div class="topradiusbg"></div>
      <div class="bh bstart r34 query-el" :class="getTopCls(topBackgroundColor)">
        <van-button @click="go('LocationHome',{local:$store.state.localValue,gps:$store.state.gpsValue})" class="btn btn-text location-btn">
          <div class="bh bstart fz_28">
            <span class="overflow">{{$store.state.localValue}}</span>
            <div class="mask-ico-whiteDown mask-contain mask-ico"></div>
          </div>
        </van-button>
        <van-button @click="go('CarGoodsQuery',{isHome:true})" class="btn btn-text query-btn r34 b1 shadow">
          <div class="bh bstart fz_28">
            <div class="b1 tl c_8B8 overflow">行车记录仪</div>
            <div class="btn-ico-el ico-query"></div>
          </div>
        </van-button>
        <div class="mask-ico-tel mask-contain mask-ico" @click="onTelClick"></div>
      </div>
      <zbSwiper :data="topBannerData.data" :options="{autoplay:3000}" designHeight="292" class="swiper-img swiper-bottom-center" v-slot:default="{ item }" @activateItemChange="onActivateItemChange">
        <div class="img-el">
          <van-image lazy-load :src="item.image" class="r10" @click="clickSwiper(item)" />
        </div>
      </zbSwiper>
      <div class="navigation r6 bh bbetween bwrap">
        <div v-for="(item, index) in classifyData" :key="index" class="bv bc navigation-item">
          <van-button @click="classifyJump(item.go)" class="btn btn-text" v-show="item.flag">
            <div class="bv bc">
              <div class="btn-ico-el" :class="item.ico"></div>
              <span class="fz_24 c_222">{{item.name}}</span>
            </div>
          </van-button>
        </div>
      </div>
      <div class="middle-banner" v-show="isMiddleBanner&&middleBannerData.data.length">
        <zbSwiper :data="middleBannerData.data" designWidth="702" designHeight="180" class="van-swiper-img" :show-indicators="false" v-slot:default="{ item }">
          <div class="img-el">
            <van-image :src="item.image" lazy-load class="r8" v-on:click="bannerGo(item.url)" />
          </div>
        </zbSwiper>
      </div>
      <div class="rubiksCube-container bh bstart" v-show="isRubiksCube">
        <div class="left bg-100" :style="{backgroundImage: `url(${rubiksCubeData[0].img})`}" @click="onRubiksCubeClick(rubiksCubeData[0])"></div>
        <div class="right">
          <div class="right-top bg-100" :style="{backgroundImage: `url(${rubiksCubeData[1].img})`}" @click="onRubiksCubeClick(rubiksCubeData[1])"></div>
          <div class="right-bottom bg-100" :style="{backgroundImage: `url(${rubiksCubeData[2].img})`}" @click="onRubiksCubeClick(rubiksCubeData[2])"></div>
        </div>
      </div>
      <carGoodsSwiper v-for="(item,index) in recommendTypeData" :data="item" :key="index"></carGoodsSwiper>
      <div>
        <div class="shop-title fz_36 c_222 fwb">推荐商品</div>
        <CarGoods :data="caraccessoriesData.data"></CarGoods>
      </div>
      <div class="bottom-bg bh bc">
        <div class="bottom-img bg-contain img-log"></div>
      </div>
    </zbScrollbar>
    <van-overlay class="dialog bv bc" :show="showDialogStyle">
      <div class="bv bc">
        <div class="guide bg-contain" :style="{backgroundImage: 'url(' + winData.image + ')'}">
          <div class="close bg-contain" @click="hideDialog"></div>
        </div>
        <van-button @click="hideDialog,bannerGo(winData.url)" class="btn btn-guide goBtn">
          <div class="fz_30">立即前往</div>
        </van-button>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import store from "@/utils/store";
import CarGoods from "@/views/car/goods/Item";
import zbScrollbar from "@/components/scroll/Bar";
import zbSwiper from "@/components/swiper/Container";
import carGoodsSwiper from "@/views/car/goods/Swiper";
import { callTel } from "@/utils/bridge";
import {
  topBanner,
  middleBanner,
  caraccessories,
  windowInfo,
  bannerStatus,
  rubiksCube,
  recommendType
} from "@/api/home";
import { find } from "lodash";
export default {
  name: "ShopHome",
  components: { CarGoods, zbScrollbar, zbSwiper, carGoodsSwiper },
  data() {
    return {
      topBackgroundColor: "",
      // 是否开启代步券
      isOpen: "",
      // 弹窗
      winData: {},
      // 顶部Banner
      topBannerData: {
        data: [],
        proxy: {
          getList: topBanner
        }
      },
      // 是否显示中间广告
      isMiddleBanner: false,
      // 中间Banner
      middleBannerData: {
        data: [],
        proxy: {
          getList: middleBanner
        }
      },
      // 是否显示魔方
      isRubiksCube: false,
      rubiksCubeData: [{}, {}, {}],
      recommendTypeData: [],
      // 车主用品
      caraccessoriesData: {
        data: [],
        proxy: {
          getList: caraccessories,
          pageSize: 10
        }
      },
      address: "",
      classifyData: [
        {
          ico: "ico-caraccessories",
          go: "CarGoodsHome",
          name: "车主用品",
          flag: true
        },
        {
          ico: "ico-lottery",
          go: "Lottery",
          name: "车主抽奖",
          flag: true
        },
        {
          ico: "ico-vehicleCurrency",
          go: "MoneyHome",
          name: "车主币",
          flag: true
        },
        {
          ico: "ico-insurance",
          go: "FeeVipHome",
          name: "会员充值",
          flag: true
        },
        {
          ico: "ico-oilCard",
          go: "FeeOilExchange",
          name: "油卡兑换",
          flag: true
        },
        {
          ico: "ico-coupon",
          name: "优惠券",
          flag: true
        },
        {
          ico: "ico-xm",
          name: "洗美服务",
          go: () => {
            this.$store.state.queryParams = { id: 149, name: '喷漆' };
            this.go("CarGoodsHome")
          },
          flag: true
        },
        { flag: false }
        // {
        //     ico: "ico-drivingservices",
        //     go: "CarDrivingList",
        //     name: "代驾服务",
        //     flag: ['test', 'dev'].includes(process.env.VUE_APP_CURRENTMODE)
        // },
        // {
        //     ico: "ico-break",
        //     go: "BreakCarHome",
        //     name: "违章查询",
        //     flag: true
        // },
        // {
        //     ico: "ico-oilCard",
        //     go: "FeeOilHome",
        //     name: "油卡充值",
        //     flag: true
        // },
        // {
        //     ico: "ico-ownerActivation",
        //     go: "UserOwnerActivation",
        //     name: "车主卡激活",
        //     flag: true
        // },
        // {
        //     ico: "ico-vouchercenter",
        //     go: "",
        //     name: "话费充值",
        //     flag: true
        // },
      ]
    };
  },
  computed: {
    // 是否显示广告
    showDialogStyle() {
      return this.$store.state.isGuide;
    },
    // 用户权限
    hasTicket() {
      return this.$store.getters["scooter/scooterVip"];
    }
  },
  watch: {
    hasTicket() {
      this.classifyData.forEach((item, index) => {
        if (item.go == "ScooterHome") {
          item.flag = this.hasTicket.hasTickets;
        }
      });
    },
    // 是否显示中间广告
    isMiddleBanner(v) {
      if (v) {
        store.load(this.middleBannerData);
      }
    },
    // 是否显示魔方
    isRubiksCube(v) {
      if (v) {
        rubiksCube().then((res) => {
          this.rubiksCubeData = res.data;
        });
      }
    }
  },
  activated() {
    this.reLoad();
  },
  created() {
    const me = this;
    store.load(me.topBannerData);
    store.load(me.caraccessoriesData);
    me.reLoad();
    // 获取广告状态
    bannerStatus().then((res) => {
      const data = res.data;
      // 是否显示魔方
      me.isRubiksCube = find(data, { id: 4 }).status;
      // 获取是否显示中间广告
      me.isMiddleBanner = find(data, { id: 3 }).status;
      // console.log("sRubiksCube", me.isRubiksCube);
      // console.log("isMiddleBanner", me.isMiddleBanner);
    });
    recommendType().then((res) => {
      me.recommendTypeData = res.data;
    });
    windowInfo().then((res) => {
      // frequency 0 首次登录弹窗, 1每次都弹窗
      const data = res.data,
        state = me.$store.state;
      if (data) {
        let is = false;
        if (!state.isLogin) {
          // 如果没有登录，弹窗广告
          is = true;
        } else if (data.frequency) {
          is = true;
        } else if (!data.frequency && state.isFirstLogin) {
          // 如果用户首次登录成功
          is = true;
          state.isFirstLogin = false;
        }
        state.isGuide = is;
        me.winData = data;
      }
    });

    function myFun(result) {
      const myGeo = new BMap.Geocoder();
      // console.log(result);
      // 根据坐标得到地址描述
      myGeo.getLocation(
        new BMap.Point(result.center.lng, result.center.lat),
        function(result) {
          // console.log(result);
          if (result) {
            me.$store.state.gpsValue = me.$store.state.localValue =
              result.addressComponents.city;
          }
        }
      );
    }
    // 百度精确定位
    const geolocation = new BMap.Geolocation();
    // 开启sdk定位
    geolocation.enableSDKLocation();
    geolocation.getCurrentPosition(function(result) {
      // console.log(result);
      if (!result) {
        // 无法定位，采用辅助定位
        const myCity = new BMap.LocalCity();
        myCity.get(myFun);
      } else {
        // 确认定位
        me.$store.state.gpsValue = me.$store.state.localValue =
          result.address.city;
      }
    });
  },
  methods: {
    classifyJump(param) {
      if (param && typeof param === "string") {
        param == "ScooterHome"
          ? this.go(param, { isOpen: this.isOpen })
          : this.go(param);
      } else if (param && typeof param === "function") {
        param()
      }
    },
    clickSwiper(item) {
      if (item.url) {
        window.location.href = item.url;
      }
    },
    hideDialog() {
      this.$store.state.isGuide = false;
    },
    onTelClick() {
      callTel(this.$store.state.tell);
    },
    // 页面刷新处理
    reLoad() {
      const me = this;
      if (me.$store.state.isApp) {
        // 检查是否显示代步车模块
        me.$store.dispatch("scooter/scooterVip");
      }
      store.reLoad(this.caraccessoriesData);
    },
    onActivateItemChange(data) {
      this.topBackgroundColor = data.backgroundColor;
    },
    getTopCls(colorValue) {
      // #123456或者rgb(12,34,56)转为rgb数组[12,34,56]
      const me = this,
        reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
      const that = colorValue;
      if (/^(rgb|RGB)/.test(that)) {
        // 处理rgb转为数组
        const aColor = that.replace(/(?:\(|\)|rgb|RGB)*/g, "").split(",");
        return me.getCls(aColor);
      } else if (reg.test(that)) {
        // 处理十六进制色值
        let sColor = colorValue.toLowerCase();
        if (sColor && reg.test(sColor)) {
          if (sColor.length === 4) {
            let sColorNew = "#";
            for (let i = 1; i < 4; i += 1) {
              sColorNew += sColor
                .slice(i, i + 1)
                .concat(sColor.slice(i, i + 1));
            }
            sColor = sColorNew;
          }
          // 处理六位的颜色值
          const sColorChange = [];
          for (let i = 1; i < 7; i += 2) {
            sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2)));
          }
          return me.getCls(sColorChange);
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    getCls(rgbArr) {
      // 当color值大于128时,color值偏向255,即#ffffff,此时字体颜色应为#000000
      // 当color值小于128时,color值偏向0,即#000000,此时字体颜色应为#ffffff
      // 因为我们在设置背景色时加了灰度80%的滤镜，所以这里数值需要乘以0.8
      const count = 0.213 * rgbArr[0] + 0.715 * rgbArr[1] + 0.072 * rgbArr[2],
        color = count * 0.8 > 255 / 2;
      return color ? "black-el" : "";
    },
    // 点击魔方
    onRubiksCubeClick({ goodsCategoryId, goodsId }) {
      const me = this;
      let name;
      switch (goodsCategoryId) {
        case 1:
          name = "CarGoodsInfo";
          break;
        case 4:
          name = "CarDrivingInfo";
          break;
        default:
          break;
      }
      me.go(name, {
        id: goodsId
      });
    }
    // onloading() {
    //     console.log(arguments)
    // }
  }
};
</script>
<style scoped lang="scss">
@include ico-list(
  "~@/assets/imges/ico/shop/",
  "caraccessories",
  "break",
  "drivingservices",
  "venosaexchange",
  "vouchercenter",
  "scooter",
  "envelope",
  "shopmaintenance",
  "insurance",
  "ownerActivation",
  "oilCard",
  "vehicleCurrency",
  "coupon",
  "lottery",
  "xm"
);
@include img-list(
  "~@/assets/imges/shop/",
  "drivingservices",
  "caraccessories",
  "log"
);
.van-button--default {
  background-color: rgba(0, 0, 0, 0);
}
.r34 {
  @include border-radius(34px);
}
//图片轮播
.van-swiper-img {
  /deep/.van-image {
    width: calc(100% - 12px);
  }
}
.swiper-bottom-center {
  .img-el {
    padding: 0 24px;
  }

  .van-swipe__indicators {
    bottom: 100px;
  }
}
.scrollbar-container {
  position: relative;
  background-color: #f5f4f4;
  .topbg {
    filter: contrast(80%);
    position: absolute;
    top: 0;
    width: 100%;
    height: 408px;
  }
  .topradiusbg {
    @include border-radius(40px 40px 0px 0px);
    background-color: #f5f4f4;
    position: absolute;
    top: 309px;
    width: 100%;
    height: 99px;
  }
  //定位与查询
  .query-el {
    height: 70px;
    padding: 23px;
    z-index: 1;
    .location-btn {
      color: #ffffff;
      width: 144px;
      .overflow {
        max-width: 4em;
      }
      .mask-ico-whiteDown {
        -webkit-mask-image: url("~@/assets/imges/ico/whiteDown.png");
        width: 22px;
        height: 12px;
        margin: 0 10px;
      }
    }
    .query-btn {
      background: rgba(255, 255, 255, 0.9);
      height: 68px;
      padding: 0 23px;
      .ico-query {
        width: 36px;
        height: 36px;
      }
    }
    .mask-ico-tel {
      -webkit-mask-image: url("~@/assets/imges/ico/tel.png");
      z-index: 1;
      margin-left: 30px;
      height: 40px;
      width: 40px;
    }
    .mask-ico {
      background-color: #fff;
    }
    &.black-el {
      .location-btn {
        color: #000;
      }
      .mask-ico {
        background-color: #000;
      }
    }
  }
  //中间部分
  //导航
  .navigation {
    @include border-radius(12px);
    width: 690px;
    margin: 0 30px;
    .navigation-item {
      flex: 0 0 25%;
      .btn-text {
        padding-top: 29px;
        .btn-ico-el {
          width: 102px;
          height: 102px;
        }
        .text {
          color: #000000;
        }
      }
    }
  }
  //中间部分
  .middle-banner {
    padding: 30px 0 0 23px;
  }

  .rubiksCube-container {
    padding: 30px 23px 0 23px;
    .left {
      width: 346px;
      height: 470px;
    }
    .right {
      padding-left: 11px;
    }
    .right-top,
    .right-bottom {
      width: 346px;
      height: 230px;
    }
    .right-bottom {
      margin-top: 10px;
    }
  }
  .shop-title {
    padding: 39px 44px 9px 44px;
  }
  .shop-img {
    margin: 30px 30px 0 30px;
    height: 180px;
  }
  .shop-list {
    padding: 0 20px;
  }
  .bottom-bg {
    padding: 37px 0 56px 0;
    .bottom-img {
      width: 175px;
      height: 60px;
    }
  }
}

.dialog {
  .btn-guide {
    width: 180px;
    height: 70px;
  }
  .goBtn {
    background-color: #f0c325;
  }
  .guide {
    width: 470px;
    height: 600px;
    position: relative;
  }
  .btn {
    margin-top: 58px;
    font-weight: bold;
  }
  .close {
    position: absolute;
    right: -40px;
    top: 46px;
    width: 39px;
    height: 39px;
    background-image: url("~@/assets/imges/ico/close.png");
  }
}
</style>